import { rankItem } from "@tanstack/match-sorter-utils";
import { FilterFn } from "@tanstack/react-table";

/**
 * A fuzzy filter function for TanStack Table that uses match-sorter utils for intelligent text matching.
 *
 * This filter provides advanced text matching capabilities including:
 * - Case-insensitive matching
 * - Special character handling
 * - Diacritic handling (accented characters)
 * - Acronym matching (e.g., "USA" matches "United States of America")
 * - Substring matching
 *
 * @param row - The table row being filtered
 * @param columnId - The ID of the column being filtered
 * @param value - The search value to match against
 * @param addMeta - Function to add metadata about the match ranking
 * @returns boolean - Returns true if the row matches the search criteria, false otherwise
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fuzzyFilter: FilterFn<any> = (row, columnId, value, addMeta) => {
  const itemRank = rankItem(String(row.getValue(columnId)), value);
  addMeta({ itemRank });
  return itemRank.passed;
};
